import * as R from 'ramda'
import { createSelector } from 'reselect'
import { getResources } from 'store/reducers/resources'
import { Resource } from 'types/typescript'
import { isNotTypeProduct, isTypeNavigation, isValidResource } from 'domain/resources'
import { createBreadcrumb } from 'domain/scope'
import { getOperationCode } from './application'
import { GetCatalogBreadcrumb, GetProductBreadcrumb } from './breadcrumbs.types'
import { getCurrentResource } from './currentResource'
import { getHasOnlyOneUniverse, getSaleResource } from './sale'
import { getIsInAllProductsScope, getScope } from './scope'
import { getCurrentResourceUniverseName } from './universes'

export const getCatalogBreadcrumb: GetCatalogBreadcrumb = createSelector(
  getResources,
  getCurrentResource,
  getCurrentResourceUniverseName,
  getScope,
  getSaleResource,
  getHasOnlyOneUniverse,
  getOperationCode,
  getIsInAllProductsScope,
  (
    allResources,
    currentResource,
    currentResourceUniverseName,
    scope,
    sale,
    saleHasOnlyOneUniverse,
    opeCode,
    isInAllProductsScope
  ) => (
    (isInAllProductsScope)
      ? [currentResourceUniverseName]
      : (isValidResource(currentResource))
          ? createBreadcrumb(currentResource as Resource, saleHasOnlyOneUniverse, scope, sale, allResources, opeCode, true)
            .filter(isTypeNavigation)
            .map(R.path(['content', 'title']))
          : []
  )
)

export const getProductBreadcrumb: GetProductBreadcrumb = createSelector(
  getResources,
  getCurrentResource,
  getScope,
  getSaleResource,
  getHasOnlyOneUniverse,
  getOperationCode,
  (allResources, currentResource, scope, sale, saleHasOnlyOneUniverse, opeCode) => (
    (isValidResource(currentResource))
      ? createBreadcrumb(currentResource as Resource, saleHasOnlyOneUniverse, scope, sale, allResources, opeCode, true)
        .filter(isNotTypeProduct)
        .map(R.path(['content', 'title']))
      : []
  )
)
